module.exports = __webpack_public_path__ + "static/icons/icon-beach--green-922d9116779e33afbeff685db1da567f.svg";